import { isEmpty } from 'lodash'

const findIdByName = (filesRemovedArray, apiFiles) => {
  if (isEmpty(filesRemovedArray) || isEmpty(apiFiles)) return []

  return filesRemovedArray?.flatMap((file) =>
    apiFiles
      .filter(
        (apiFile) =>
          apiFile.name === file.name || apiFile.url.includes(file.name),
      )
      .map((apiFile) => apiFile.id),
  )
}

export default findIdByName
